import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import softwareProjectsData from "../data/projects/software.json";
import systemsProjectsData from "../data/projects/systems.json";
import roboticsProjectsData from "../data/projects/robotics.json";
import { getImageByKey } from "../data/imageMap";

import colorSharp2 from "../assets/img/color-sharp2.webp";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const softwareProjects = softwareProjectsData.map((project) => ({
    ...project,
    imgUrl: getImageByKey(project.imageKey),
  }));

  const systemsProjects = systemsProjectsData.map((project) => ({
    ...project,
    imgUrl: getImageByKey(project.imageKey),
  }));

  const roboticsProjects = roboticsProjectsData.map((project) => ({
    ...project,
    imgUrl: getImageByKey(project.imageKey),
  }));

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility once>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>A collection of things I've built</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first" className="minimal-tab">
                          Software
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second" className="minimal-tab">
                          Systems
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third" className="minimal-tab">
                          Robotics
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>

                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                      style={{
                        padding: "20px",
                      }}
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {softwareProjects.map((project, index) => (
                            <ProjectCard key={index} {...project} />
                          ))}
                        </Row>
                      </Tab.Pane>

                      <Tab.Pane eventKey="second">
                        <Row>
                          {systemsProjects.map((project, index) => (
                            <ProjectCard key={index} {...project} />
                          ))}
                        </Row>
                      </Tab.Pane>

                      <Tab.Pane eventKey="third">
                        <Row>
                          {roboticsProjects.map((project, index) => (
                            <ProjectCard key={index} {...project} />
                          ))}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img
        className="background-image-right"
        src={colorSharp2}
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
      />
    </section>
  );
};
